import { ReactElement, useMemo } from "react"
// eslint-disable-next-line import/no-extraneous-dependencies
import EChartsReact from "echarts-for-react"

import { ReportData } from "../../../../interfaces/markets"

type Props = {
  data: ReportData
}

const statusConfig = {
  validCount: { label: "Valid Records", color: "#10B981" },
  invalidKeysCount: { label: "Unknown Items", color: "#ff4d4f" },
  invalidSeriesCount: { label: "Series Not Enabled", color: "#ff7875" },
  invalidDateCount: { label: "Invalid Dates", color: "#ffa39e" },
  duplicatedCount: { label: "Duplicate Records", color: "#fa8c16" },
  discardedCount: { label: "Discarded Records", color: "#faad14" },
} as const

const StatusChart = ({ data }: Props): ReactElement => {
  const chartData = useMemo(() => {
    return Object.entries(statusConfig)
      .map(([key, config]) => ({
        name: config.label,
        value: data[key as keyof typeof statusConfig],
        itemStyle: { color: config.color },
      }))
      .filter(item => item.value > 0)
  }, [data])

  const option = {
    legend: { show: true, bottom: 0, itemGap: 8 },
    tooltip: {
      trigger: "item",
      formatter: "{b}: <b>{c}</b> ({d}%)",
    },
    series: [
      {
        name: "Observations",
        type: "pie",
        radius: ["30%", "60%"],
        avoidLabelOverlap: false,
        label: {
          formatter: "{d}%",
          position: "inside",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 13,
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
        data: chartData,
      },
    ],
  }

  return <EChartsReact option={option} style={{ height: 350, width: 350 }} notMerge lazyUpdate className="m-auto" />
}

export default StatusChart
